export const INITIAL = 'INITIAL';
export const NOTSEEN = 'NOTSEEN';
export const SEEN = 'SEEN';
export const ERROR = 'ERROR';
export const PACKAGE_NAME = 'jiraServicedeskItsmFirstSessionFlow';
export const TEAM_NAME = 'itops-mithril';
